webpackJsonp([1],{

/***/ "+Lbl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('audio',{attrs:{"id":"audio","src":"./static/asstes/bg-audio.mp3","preload":"","loop":"loop"}}),_vm._v(" "),(_vm.isNav)?_c('Navigation'):_vm._e(),_vm._v(" "),(_vm.isPark)?_c('ParkDetail',{attrs:{"title":_vm.title}}):_vm._e(),_vm._v(" "),(_vm.isTower)?_c('TowerDetail',{attrs:{"towerTitle":_vm.tower,"towerData":_vm.towerData}}):_vm._e(),_vm._v(" "),(_vm.isAreas)?_c('AreasDetail',{attrs:{"selectArea":_vm.selectArea}}):_vm._e(),_vm._v(" "),(_vm.isLogin)?_c('Login'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"pano"}}),_vm._v(" "),(_vm.isShowUser)?_c('div',{staticClass:"btn",on:{"click":function($event){_vm.handleLogin(true)}}},[_c('van-icon',{staticClass:"user",attrs:{"name":"contact"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2vhm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4SXU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5fVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.isShow ? 'opacityBgUnshow' : 'opacityBgShow') +'  navigation'},[_c('ul',{staticClass:"box"},[_c('li',{staticClass:"item5",style:({background: _vm.isShow ? '#d91748' : '#d91748' }),on:{"click":function($event){_vm.isShow = !_vm.isShow}}},[_c('span')]),_vm._v(" "),_c('transition-group',{attrs:{"name":"slide-fade"}},_vm._l((_vm.list),function(item,index){return (_vm.isShow)?_c('li',{key:item.id,class:'item'+(index+1)+' item',on:{"click":function($event){_vm.handleNav(item.nav,true)}}},[_c('div',{style:({backgroundColor:item.isShow?'rgba(0,0,0,0.2)': 'rgba(0,0,0,0.8)'})},[_vm._v(_vm._s(item.name)+" ")])]):_vm._e()}))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5xsX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"Login",attrs:{"id":"Login"}},[_c('van-icon',{staticClass:"icon-close",attrs:{"name":"close"},on:{"click":function($event){_vm.$parent.handleLogin(false)}}}),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"label":"用户名","placeholder":"请输入用户名","required":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('van-field',{attrs:{"type":"password","label":"密码","placeholder":"请输入密码","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('van-button',{staticClass:"btn",attrs:{"size":"large","type":"primary"},on:{"click":_vm.login}},[_vm._v("登入")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6xRK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8YgA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Vtour_vue__ = __webpack_require__("uqcv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2ad5c00e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Vtour_vue__ = __webpack_require__("+Lbl");
function injectStyle (ssrContext) {
  __webpack_require__("LmQH")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ad5c00e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Vtour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2ad5c00e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Vtour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8kHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'areas-detail '+ _vm.selectArea},[_c('ul',{staticClass:"btn",on:{"click":function($event){_vm.$parent.isShowAreas(false)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EGLg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        towerTitle: String,
        towerData: Object
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        test: function test() {
            console.log('test');
        }
    },
    components: {}
});

/***/ }),

/***/ "Ez2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__("xaRl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4b71d47d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__("5fVt");
function injectStyle (ssrContext) {
  __webpack_require__("4SXU")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b71d47d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4b71d47d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fae6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"park-detail"},[_c('div',{staticClass:"box"},[_c('ul',{staticClass:"header"},[_c('li',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+"基本信息")]),_vm._v(" "),_c('li',{staticClass:"btn",on:{"click":function($event){_vm.$parent.isShowPark(false)}}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"footer"},[(_vm.title != '张江中区')?_c('div',[_c('div',[_vm._v("      "+_vm._s(_vm.resData.detail))]),_vm._v(" "),_c('ul',{staticClass:"listDetail"},_vm._l((_vm.resData.listDetail),function(item,index){return _c('li',{key:index+'1',staticStyle:{"width":"100%","overflow":"hidden"}},[_c('p',{staticClass:"title",staticStyle:{"color":"#000"}},[_vm._v(_vm._s(item.name))]),_c('span',{staticClass:"detail"},[_vm._v(_vm._s(item.detail)+" ")])])}))]):_c('div',{staticStyle:{"margin-top":"30px"}},[_c('div',[_vm._v("      "+_vm._s(_vm.resData.detailTop))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("      "+_vm._s(_vm.resData.detailAdd))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("      "+_vm._s(_vm.resData.detailCenter))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("      "+_vm._s(_vm.resData.detailBottom))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G/Bm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LmQH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lw/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tower-detail"},[_c('ul',{staticClass:"header"},[_c('li',{staticClass:"title"},[_vm._v(_vm._s(_vm.towerTitle))]),_vm._v(" "),_c('li',{staticClass:"tip"},[_vm._v("热门楼层")]),_vm._v(" "),_c('li',{staticClass:"btn",on:{"click":function($event){_vm.$parent.isShowTower(false)}}})]),_vm._v(" "),_c('ul',{staticClass:"footer"},[_c('div',{key:"title-f-1",staticClass:"title-f"},[_vm._v("建筑详情")]),_vm._v(" "),_vm._l((_vm.towerData.towerDetail),function(item,index){return _c('li',{key:index+'1',staticStyle:{"width":"100%","overflow":"hidden"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.name)+"：")]),_c('span',{staticClass:"detail"},[_vm._v(_vm._s(item.detail)+" ")])])}),_vm._v(" "),(_vm.towerData.signRecords)?_c('div',{key:"title-f-2",staticClass:"title-f",staticStyle:{"margin-top":"15px"}},[_vm._v("签约记录")]):_vm._e(),_vm._v(" "),_vm._l((_vm.towerData.signRecords),function(item,index){return _c('li',{key:index+'2',staticStyle:{"width":"100%","overflow":"hidden"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.lookBuildingName)+"：")]),_c('span',{staticClass:"detail"},[_vm._v(_vm._s(item.curCompany)+" ")])])}),_vm._v(" "),(_vm.towerData.lookRecords)?_c('div',{key:"title-f-3",staticClass:"title-f",staticStyle:{"margin-top":"15px"}},[_vm._v("最近看房记录 ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.towerData.lookRecords),function(item,index){return _c('li',{key:index+'3',staticStyle:{"width":"100%","overflow":"hidden"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.lookFloorInfo)+"：")]),_c('span',{staticClass:"detail"},[_vm._v(_vm._s(item.curCompany)+" ")])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6b6af2f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("QXr+");
function injectStyle (ssrContext) {
  __webpack_require__("rxtR")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6b6af2f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("IvJb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant__ = __webpack_require__("GdJK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_lib_vant_css_index_css__ = __webpack_require__("wmK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_lib_vant_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vant_lib_vant_css_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
// vant 组件


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vant___default.a);
/* eslint-disable no-new */
window.vue = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "QXr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QhrR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("IvJb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("zO6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Vtour__ = __webpack_require__("8YgA");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Vtour',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Vtour__["a" /* default */]
  }]
}));

/***/ }),

/***/ "mCwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant__ = __webpack_require__("GdJK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_axios_js__ = __webpack_require__("zFqy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_md5__ = __webpack_require__("KPSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_md5__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    login: function login() {
      if (this.username && this.password) {
        __WEBPACK_IMPORTED_MODULE_2__config_axios_js__["a" /* default */].post('user/panoUserLogin.do', { username: this.username, password: __WEBPACK_IMPORTED_MODULE_3_js_md5___default()(this.password) }).then(function (res) {
          if (res.code == '000000') {
            window.localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.token));
            window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
            window.location.href = window.location.href;
          }
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_vant__["Toast"])('账号或者密码不能为空');
      }
    }
  }
});

/***/ }),

/***/ "oYSq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_TowerDetail_vue__ = __webpack_require__("EGLg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ea74252e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_TowerDetail_vue__ = __webpack_require__("Lw/9");
function injectStyle (ssrContext) {
  __webpack_require__("2vhm")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea74252e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_TowerDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ea74252e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_TowerDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rHwf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		title: String
	},
	data: function data() {
		return {
			data: [{
				title: '人工智能岛',
				detail: '人工智能岛，企业总部的梦想家园，毗邻川杨河及张江中区未来公园，依林而建，傍水而居，实为嘈杂城市钢筋水泥中的一篇科技绿洲。有水的地方就有了活力，有水的地方就有了灵性。来这里，激起一场科技与灵感的碰撞，来这里，造就一坐生机勃勃的科学城。张江中区科创园，科技内涵域产城融合的典范之作。',
				listDetail: [{ name: '租赁总面积', detail: '10.2万平方米' }, { name: '楼板载荷', detail: '350kg/m2' }, { name: '建筑层数', detail: 'A区6层，B区3-4层，C区4层' }, { name: '标准层高', detail: 'A区4.5m，B区4.2m' }, { name: '客用电梯', detail: 'A区4部客梯，B区1部客梯' }, { name: '空调系统', detail: '集中供能' }, { name: '停车位', detail: '1000个' }, { name: '地址', detail: '上海市浦东新区上科路366号' }, { name: '交通', detail: '13号线、园区班车' }, { name: '建筑户型1', detail: '21' }, { name: '建筑户型2', detail: '1 ~ 4' }, { name: '建筑户型3', detail: '5 ~ 20' }]
			}, {
				title: '研创园',
				detail: '研创园以打造中国研发创新高地为目标，集聚各类研发机构、创新服务平台和科研人才，营造资源共享、信息通达、各学科交叉融合的创新创业环境，为入驻企业打造研发资源聚集，创新氛围浓厚的总部级生态商务群落。',
				listDetail: [{ name: '租赁总面积', detail: '5.8 万平方米' }, { name: '楼板载荷', detail: '300kg/m2' }, { name: '建筑层数', detail: '小高层共11层，小独栋4-5层' }, { name: '标准层高', detail: '小高层4.5米，小独栋3.9米' }, { name: '客用电梯', detail: '采用通力品牌，小独栋每幢1部，小高层4部' }, { name: '空调系统', detail: '小高层集中供能，小独栋预留VRV机位' }, { name: '停车位', detail: '565个' }, { name: '地址', detail: '上海市浦东新区学林路36弄' }, { name: '交通', detail: '1地铁13号线，园区班车' }, { name: '建筑户型1', detail: '1，2' }, { name: '建筑户型2', detail: '4，10' }, { name: '建筑户型3', detail: '3，7，11' }, { name: '建筑户型4', detail: '5，6，8，9' }, { name: '建筑户型5', detail: '12，13，14' }, { name: '建筑户型6', detail: '15，16，17，18，19' }]
			}, {
				title: '国际人才港',
				detail: '国际人才港定位于高端的创新领地，以金融科技产业为核心，聚集高端产业机构，搭建高效运营机制，构筑资源整合大平台，与全球金融企业一起引领行业风向，开启科技金融新时代。',
				listDetail: [{ name: '租赁总面积', detail: '5.4万平方米' }, { name: '楼板载荷', detail: '350kg/m2' }, { name: '建筑层数', detail: '小高层共13层，小独栋4-5层' }, { name: '标准层高', detail: '小高层4.1米，小独栋3.9米' }, { name: '客用电梯', detail: '采用通力品牌，小独栋每幢1部，小高层3部' }, { name: '空调系统', detail: '集中供能' }, { name: '停车位', detail: '500个' }, { name: '地址', detail: '上海市浦东新区环科路999弄' }, { name: '交通', detail: '13号线、园区接驳班车' }, { name: '建筑户型1', detail: '9，10' }, { name: '建筑户型2', detail: '2，3，5，6，7，8' }, { name: '建筑户型3', detail: '25，23，22，21，18，17，16，15，12' }]
			}, {
				title: '张江中区基本信息',
				detailTop: '张江高科技园区，被誉为中国硅谷。成立于1992年7月，位于上海浦东新区中南部，是中国国家级高新技术园区，与陆家嘴、金桥和外高桥开发区同为上海浦东新区四个重点开发区域。',
				detailAdd: '经过近二十年的开发，园区建筑了生物医药创新链、集成电路产业链和软件产业链的框架。',
				detailCenter: '园区有国家上海生物医药科技产业基地、国家信息产业基地、国家集成电路产业基地、国家半导体照明产业基地、国家863信息安全成果产业化（东部）基地、国家软件产业基地、国家软件出口基地、国家文化产业示范基地、国家网游动漫产业发展基地等多个国家级基地。键有国家火炬创业园、国家留学人员创业园。',
				detailBottom: '张江高科技园区正向着世界级高科技园区的愿景目标阔步前进。',
				listDetail: []
			}]

		};
	},
	mounted: function mounted() {
		// console.log(this.title,'title111')
	},


	methods: {},
	components: {},
	computed: {
		resData: function resData() {
			if (this.title == '人工智能岛') {
				return this.data[0];
			} else if (this.title == '研创园') {
				return this.data[1];
			} else if (this.title == '国际人才港') {
				return this.data[2];
			} else {
				return this.data[3];
			}
		}
	}
});

/***/ }),

/***/ "rxtR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "sRqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_AreasDetail_vue__ = __webpack_require__("xZ46");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_18146076_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_AreasDetail_vue__ = __webpack_require__("8kHf");
function injectStyle (ssrContext) {
  __webpack_require__("QhrR")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18146076"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_AreasDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_18146076_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_AreasDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uaSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_ROOT_DEV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENV_ROOT_DEV; });
var API_ROOT_DEV = 'http://10.10.3.64:8080'; // 测试环境的接口地址
var ENV_ROOT_DEV = 'http://106.14.29.228:8080/'; // 运行环境

//export const API_ROOT_PRO = 'http://bosstest.fanqiebianli.com/api/' // 线上环境

/***/ }),

/***/ "uqcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commonComponents_Navigation_vue__ = __webpack_require__("Ez2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_ParkDetail_vue__ = __webpack_require__("y5OO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_TowerDetail_vue__ = __webpack_require__("oYSq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_AreasDetail_vue__ = __webpack_require__("sRqH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant__ = __webpack_require__("GdJK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Login_vue__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_axios_js__ = __webpack_require__("zFqy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'vtour',
    data: function data() {
        return {
            isShowUser: false,
            isShowVtour: 'true',
            loginText: '登入',
            isLogin: false,
            isPark: false,
            isTower: false,
            tower: 'A11111',
            isNav: false,
            isAreas: false,
            selectArea: 'bg-image-hall',
            title: '张江中区',
            parkData: [],
            towerData: {
                towerDetail: [],
                lookRecords: [],
                signRecords: []
            },
            sign: true
        };
    },
    created: function created() {
        window.vtour = {
            isShowPark: this.isShowPark,
            isShowTower: this.isShowTower,
            isShowNav: this.isShowNav,
            isShowAreas: this.isShowAreas,
            getTowerState: this.getTowerState,
            requestFullScreen: this.requestFullScreen,
            exitFull: this.exitFull,
            audioIsPlay: this.audioIsPlay
        };
    },
    mounted: function mounted() {
        embedpano({ swf: "./static/vtour/tour.swf", xml: "./static/vtour/tour.xml", target: "pano", html5: "auto", mobilescale: 1.0, passQueryParameters: true, onready: this.krpano_onready_callback });
        document.onclick = this.showXY;

        // window.setTimeout(function(){
        //     const audio = document.getElementById('audio')
        //     // alert('1111')
        //     audio.play()
        // },10000)
        // this.iosPlay()
    },

    watch: {},
    methods: {
        iosPlay: function iosPlay() {
            var self = this;
            document.addEventListener('touchstart', function () {
                function audioAutoPlay(a) {
                    if (a) {
                        var audio = document.getElementById('audio');
                        audio.play();
                        // this.krpano.call("set(layer[%1].crop, '900|100|100|100');")
                        self.sign = false;
                    }
                }
                audioAutoPlay(self.sign);
            });
        },
        audioIsPlay: function audioIsPlay(isPlay) {
            var audio = document.getElementById('audio');
            console.log(audio.autoplay, 'audio');
            if (isPlay) {
                audio.play();
            } else {
                window.setTimeout(function () {
                    audio.pause();
                }, 100);
            }
        },
        handleLogin: function handleLogin(sign) {
            this.isLogin = sign;
            // Toast('登入过期！请重新登入')
        },
        requestFullScreen: function requestFullScreen() {
            var element = document.documentElement;
            // 判断各种浏览器，找到正确的方法
            var requestMethod = element.requestFullScreen || //W3C
            element.webkitRequestFullScreen || //Chrome等
            element.mozRequestFullScreen || //FireFox
            element.msRequestFullScreen; //IE11
            if (requestMethod) {
                requestMethod.call(element);
            } else if (typeof window.ActiveXObject !== "undefined") {
                //for Internet Explorer
                var wscript = new ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                    wscript.SendKeys("{F11}");
                }
            }
        },
        exitFull: function exitFull() {
            console.log('exitFull');
            // 判断各种浏览器，找到正确的方法
            var exitMethod = document.exitFullscreen || //W3C
            document.mozCancelFullScreen || //Chrome等
            document.webkitExitFullscreen || //FireFox
            document.webkitExitFullscreen; //IE11
            if (exitMethod) {
                exitMethod.call(document);
            } else if (typeof window.ActiveXObject !== "undefined") {
                //for Internet Explorer
                var wscript = new ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                    wscript.SendKeys("{F11}");
                }
            }
        },
        getTowerData: function getTowerData(code) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_6__config_axios_js__["a" /* default */].post('pano/selectPanoBuildingInfo.do', { code: code }).then(function (data) {
                // if(data.data.tokenState == 0 ){

                //     if(JSON.parse(localStorage.getItem('token'))){
                //         this.handleLogin(true)
                //         Toast('登入过期！请重新登入')
                //         localStorage.removeItem('token');
                //     }
                // }
                data = data.data;
                if (data.signRecords) {
                    data.signRecords.forEach(function (item1) {
                        if (item1.leaseType == 0) {
                            item1.towerTitle = _this.tower;
                        } else {
                            item1.towerTitle = _this.lookFloorInfo;
                        }
                    });
                }

                data.towerDetail = [];
                var temp = data.desp.split('#pano1#');

                temp.forEach(function (item) {
                    var tempObj = {};
                    var temp1 = item.split('#pano#');
                    tempObj.name = temp1[0];
                    tempObj.detail = temp1[1];
                    data.towerDetail.push(tempObj);
                });
                _this.towerData = data;

                console.log(data, 'data');
            }).catch(function (err) {
                console.log('err', err);
            });
        },
        getTowerState: function getTowerState(code) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_6__config_axios_js__["a" /* default */].post('dir/selectParkList.do', { parentCode: code }).then(function (data) {
                // if(data.data.tokenState == 0 ){
                //     if(JSON.parse(localStorage.getItem('token'))){
                //          this.handleLogin(true)
                //         Toast('登入过期！请重新登入')
                //         localStorage.removeItem('token');
                //     }
                // }
                _this2.parkData = data.data;
                var sign = 't';
                if (code == '100') {
                    sign = 't';
                } else if (code == '101') {
                    sign = 'y';
                } else {
                    sign = 'k';
                }
                if (localStorage.getItem('token') && data.data.tokenState != 0) {
                    data.data.parks.forEach(function (item) {
                        if (item.state == 0) {
                            _this2.krpano.call("set(hotspot[titile-" + sign + "-" + item.name + "].url,'./static/vtour/bgpic/gray.png');set(hotspot[titile-" + sign + "-" + item.name + "].tooltip,'待定')");
                        } else if (item.state == 1) {
                            _this2.krpano.call("set(hotspot[titile-" + sign + "-" + item.name + "].url,'./static/vtour/bgpic/gray.png');set(hotspot[titile-" + sign + "-" + item.name + "].tooltip,'有意向')");
                        } else if (item.state == 2) {
                            _this2.krpano.call("set(hotspot[titile-" + sign + "-" + item.name + "].url,'./static/vtour/bgpic/blue.png');set(hotspot[titile-" + sign + "-" + item.name + "].tooltip,'预约')");
                        } else if (item.state == 3) {
                            _this2.krpano.call("set(hotspot[titile-" + sign + "-" + item.name + "].url,'./static/vtour/bgpic/red.png');set(hotspot[titile-" + sign + "-" + item.name + "].tooltip,'签约')");
                        } else if (item.state == 4) {
                            _this2.krpano.call("set(hotspot[titile-" + sign + "-" + item.name + "].url,'./static/vtour/bgpic/green.png');set(hotspot[titile-" + sign + "-" + item.name + "].tooltip,'空置')");
                        } else {
                            _this2.krpano.call("set(hotspot[titile-" + sign + "-" + item.name + "].url,'./static/vtour/bgpic/red.png');set(hotspot[titile-" + sign + "-" + item.name + "].tooltip,'空置')");
                        }
                    });
                } else {
                    data.data.parks.forEach(function (item) {
                        _this2.krpano.call("set(hotspot[titile-" + sign + "-" + item.name + "].url,'./static/vtour/bgpic/gray.png')");
                    });
                }
            }).catch(function (err) {
                console.log('err', err);
            });
        },
        editTittle: function editTittle(title) {
            switch (title) {
                case 'scene_hp-1-t':
                    this.title = '国际人才港';break;
                case 'scene_hp-3-y':
                    this.title = '研创园';break;
                case 'scene_hp3g-k':
                    this.title = '人工智能岛';break;
                case 'scene_hp-n':
                    this.title = '张江中区';break;
                default:
                    break;
            }
        },
        isShowAreas: function isShowAreas(isShow, select) {
            if (isShow) {
                this.isAreas = true;
                this.selectArea = select;
            } else {
                this.isAreas = false;
            }
        },

        // 小行星运行完毕
        isShowNav: function isShowNav() {
            this.isNav = true;
            this.isShowUser = true;
        },
        showXY: function showXY() {
            var mx = this.krpano.get("mouse.x");
            var my = this.krpano.get("mouse.y");
            var pnt = this.krpano.screentosphere(mx, my);
            var h = pnt.x;
            var v = pnt.y;
            console.log('x="' + mx + '" y="' + my + '" ath="' + h.toFixed(2) + '" atv="' + v.toFixed(2) + '"');
        },
        krpano: function krpano() {},
        krpano_onready_callback: function krpano_onready_callback(obj) {
            console.log('krpano');
            window.krpano = obj;
            this.krpano = obj;
        },
        isShowPark: function isShowPark(isShow) {

            if (isShow) {
                this.isPark = true;
            } else {
                this.isPark = false;
                // krpano.call("set(layer[lefttop_icon04].crop, '400|0|100|100')")
            }
        },
        isShowTower: function isShowTower(isShow, tower) {
            if (tower && this.tower !== tower) {
                // 这里楼层的信息
                this.tower = tower;
                var code = '';
                this.parkData.parks.forEach(function (item) {
                    if (item.name == tower) {
                        code = item.code;
                    }
                });
                if (code) {
                    this.getTowerData(code);
                }
            }
            if (isShow) {
                this.isTower = true;
            } else {
                this.isTower = false;
            }
        }
    },
    components: { Navigation: __WEBPACK_IMPORTED_MODULE_0__commonComponents_Navigation_vue__["a" /* default */], ParkDetail: __WEBPACK_IMPORTED_MODULE_1__commonComponents_ParkDetail_vue__["a" /* default */], TowerDetail: __WEBPACK_IMPORTED_MODULE_2__commonComponents_TowerDetail_vue__["a" /* default */], AreasDetail: __WEBPACK_IMPORTED_MODULE_3__commonComponents_AreasDetail_vue__["a" /* default */], Login: __WEBPACK_IMPORTED_MODULE_5__Login_vue__["a" /* default */] }
});

/***/ }),

/***/ "wmK6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("mCwr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4923194a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("5xsX");
function injectStyle (ssrContext) {
  __webpack_require__("6xRK")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4923194a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4923194a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xZ46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    selectArea: String
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {
    handleClose: function handleClose() {}
  },
  components: {}
});

/***/ }),

/***/ "xaRl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			isShow: false,
			list: [{ name: '国际人才港', id: 1, isShow: false, nav: 'scene_hp-1-t' }, { name: '研创园', id: 2, isShow: false, nav: 'scene_hp-3-y' }, { name: '人工智能岛', id: 3, isShow: false, nav: 'scene_hp3g-k' }, { name: '园区总览', id: 4, isShow: true, nav: 'scene_hp-n' }],
			update: false
		};
	},
	mounted: function mounted() {
		window.vtour.handleNav = this.handleNav;
	},

	methods: {
		handleNav: function handleNav(nav, isToH5) {
			if (this.$parent.krpano.get('xml').scene === nav) {} else {
				this.$parent.editTittle(nav);
				this.list.forEach(function (item) {
					if (item.nav === nav) {
						item.isShow = true;
					} else {
						item.isShow = false;
					}
				});
				this.$parent.isShowTower(false);
				this.update = !this.update;
				if (isToH5) {
					krpano.call("set(layer[lefttop_icon05].crop, '1500|100|100|100');");
					this.$parent.krpano.call('toscene1(false,' + nav + ')');
					if (nav === 'scene_hp-1-t') {
						this.$parent.getTowerState(100);
					} else if (nav == 'scene_hp-3-y') {
						this.$parent.getTowerState(101);
					} else if (nav == 'scene_hp3g-k') {
						this.$parent.getTowerState(102);
					} else {}
				}
			}
		}
	},
	components: {}
});

/***/ }),

/***/ "y5OO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ParkDetail_vue__ = __webpack_require__("rHwf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_12156e06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ParkDetail_vue__ = __webpack_require__("Fae6");
function injectStyle (ssrContext) {
  __webpack_require__("G/Bm")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12156e06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ParkDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_12156e06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ParkDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zFqy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("6iV/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant__ = __webpack_require__("GdJK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__env_js__ = __webpack_require__("uaSg");






var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_4__env_js__["a" /* ENV_ROOT_DEV */],
  timeout: 30000,
  headers: {
    'Content-type': 'application/json'
  }
});
// http.defaults.headers.common['Authorization'] = 'Bearer ' + cookies.get('token')
http.interceptors.request.use(function (config) {
  window.krpano.call('skin_showloading(true)');
  // 在发送请求之前做某件事
  // 若是有做鉴权token , 就给头部带上token

  config.headers.token = JSON.parse(localStorage.getItem('token')) ? JSON.parse(localStorage.getItem('token')) : '';

  // if (localStorage.getItem('token')) {
  //   config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
  // }
  if (config.method === 'post') {
    // 序列化
    config.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.data); // ***** 这里转义
  }
  return config;
}, function (err) {
  // return Promise.reject(err)
});
//拦截器(返回拦截) 只有接口错误做处理，正确不做处理
http.interceptors.response.use(function (res) {
  window.krpano.call('skin_showloading(false)');
  // window._global.isLoading= false
  if (res.status === 200) {
    //判断验证信息
    if (res.data.code !== '000000') {
      Object(__WEBPACK_IMPORTED_MODULE_3_vant__["Toast"])(res.data.message);
      if (res.data.code === '100005') {
        // 登入超时跳刀登入页面重新登入
        window.localStorage.removeItem('token');
      }
    } else {}
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_3_vant__["Toast"])('网络错误');
  }
  return res.data;
}, function (err) {
  // 这里是500
  Object(__WEBPACK_IMPORTED_MODULE_3_vant__["Toast"])('网络错误');
  // err.message= '请检查网络'
  // return Promise.reject(err)
});
/* harmony default export */ __webpack_exports__["a"] = (http);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.29c8e3b621ad0135eb26.js